module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "cdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("UN building, New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Josh MacArthur reached")]), _vm._v(" into his pocket for a tissue to blow his nose before remembering that he had used the last one a few minutes ago. He closed his eyes as he sneezed, his whole body shaking with the force.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Allergies,” he mumbled, getting up from his seat. “I just … need … a … tish—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He sneezed before he could finish the sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mumbling another apology, Josh made his way to the private restroom at the side of the office, pushing through the door as his body was wracked by a quick success of sneezes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Damn allergies!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His allergies had saved his life in Vietnam. But on the whole, he would just as well do without them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were no more tissues in the box on the shelf above the sink. Josh grabbed a length of toilet paper and unfurled it, folding it over quickly and then trying to clear the mess from his nose. It was a lost cause, as were antihistamines, saline sprays, and all manner of remedies he’d tried over the years. Removing the allergen was the only "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("real")]), _vm._v(" solution.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But what the hell was the allergen here, midway up the UN building, in the middle of a block of offices whose windows didn’t even open?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh sneezed again. He cleared his nose, dumped some of the paper into the toilet, and flushed. He sneezed, blew his nose, then felt his sinuses clear a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sneezing fit finally over, he turned to the sink and ran the cold water, splashing on it on his face. He looked at himself in the mirror. He looked more than a little worse for wear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh patted his face dry—rubbing his eyes would only make them hurt even more—then took a deep breath, trying to relax.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a tap on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You, uh, all right in there, Josh?” asked William Jablonski, a political consultant to the President who’d been pressed into service as his minder and media adviser. Jablonski slurred the “sh”; with his deep voice, it sounded as if he were hushing him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, yeah. Just getting my breath back.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The reporters have a few more questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh sat on the closed seat of the toilet and unrolled some more toilet tissue. When he’d been stuck behind the lines in Vietnam, he’d dreamed of the chance to tell the world what he had seen. That goal had kept him going, kept him alive. But at this point he really could use a break. A little more of a rest.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("The questions were the same, over and over. He repeated the answers practically word for word:")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Where did this happen?")])]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Vietnam, the jungles near the Chinese border.")])]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("You saw all of this with your own eyes?")])]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Yes.")])]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("How did you escape?")])]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I had a phone—some SEALs were sent. And I guess, uh, some Army guys.")])]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_vm._v("The last answer was, if not quite a lie, certainly not the whole truth. CIA officer Mara Duncan had been the person who found him in the jungle and truly saved him—the CIA had tracked his phone signal, then sent Mara to find and rescue him. But mentioning her—mentioning the agency’s involvement at all—would blow her cover, ending her usefulness in Southeast Asia, and probably ending or at least harming her career.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So he left her out of the answers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Josh?” asked Jablonski through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You sure you’re all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m good.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The people from WINS have, uh, a deadline thing that they are hoping to meet. They want to talk, uh, about the bridge.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll be out in just a sec,” Josh told him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bridge. Someone had tried to blow him up, to stop him from getting to the UN. Those questions were harder to answer, since he wasn’t exactly sure who it was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("was")]), _vm._v(" sure—he saw the man in his mind’s eye: early twenties, thin face, shaved head. Chinese, definitely Chinese.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Determined expression. Cold, hollow eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Can’t they all just go away?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suddenly he felt ashamed of himself. The people in Vietnam whose bodies he’d seen—they would gladly trade places with him. M"), _c('span', {
    staticClass: "epub-accent-r"
  }, [_vm._v("ạ")]), _vm._v(", the little girl he’d rescued: What would she think?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh rose, blew his nose again, then opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“All right,” he said to the reporters as he emerged. “Where were we?”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 92
// module chunks = 0